export const iconFontAwesomeLogisticsTruckFront = (
	<i className="fa-solid fa-truck-front"></i>
);
